import React from 'react'

interface CurrencyProps {
  children: number
}

export const Currency: React.FC<CurrencyProps> = ({ children }) => {
  let numberValue = children

  if (isNaN(numberValue - 0)) {
    console.warn('You have given Currency component a non number child value. Please give a number')
    numberValue = 0
  }

  return <>{`${numberValue.toFixed(2).replace('.', ',')} €`}</>
}
